import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import { getBlogPost } from "../lib/api";
import { Reveal } from "../components/Primitives";
import { IMAGES } from "../data/content";

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    getBlogPost(slug)
      .then(setPost)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <div className="pt-44 pb-32 container-loft"><div className="card-soft h-96 animate-pulse" /></div>;
  }

  if (error || !post) {
    return (
      <div className="pt-44 pb-32 container-loft text-center" data-testid="journal-post-notfound">
        <h1 className="font-serif text-4xl text-[#EFE7FA]">Article not found</h1>
        <Link to="/journal" className="btn-ghost mt-8 inline-flex">Back to Journal</Link>
      </div>
    );
  }

  return (
    <div data-testid="journal-post-page">
      <section className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden grain">
        <img src={post.cover} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#120726] via-[#120726]/85 to-[#120726]/60" />
        <div className="container-loft relative z-10 max-w-3xl mx-auto text-center">
          <Reveal>
            <Link to="/journal" className="inline-flex items-center gap-2 text-sm text-[#C4A2E8] mb-6 hover:gap-3 transition-all">
              <ArrowLeft size={16} /> Back to Journal
            </Link>
            <div className="flex items-center justify-center gap-4 mb-5">
              <span className="overline text-[#4FD6AD]">{post.category}</span>
              <span className="flex items-center gap-1 text-xs text-[#EFE7FA]/50"><Clock size={13} /> {post.read_time}</span>
            </div>
            <h1 className="font-serif text-4xl md:text-6xl font-light leading-tight text-[#EFE7FA]">{post.title}</h1>
          </Reveal>
        </div>
      </section>

      <section className="pb-28 bg-[#1a0d33] pt-4">
        <div className="container-loft max-w-2xl mx-auto">
          <Reveal>
            <p className="font-serif text-2xl md:text-3xl font-light italic leading-relaxed text-[#C4A2E8] mb-10">
              {post.excerpt}
            </p>
            <div className="text-lg font-light leading-relaxed text-[#EFE7FA]/80 space-y-6">
              {post.body.split("\n").map((para, i) => <p key={i}>{para}</p>)}
            </div>
            <div className="divider-line my-12" />
            <div className="flex items-center gap-4">
              <img src={IMAGES.emblem} alt="" className="h-12 w-12 object-contain" />
              <div>
                <p className="font-serif text-xl text-[#EFE7FA]">Shantel London</p>
                <p className="text-sm text-[#EFE7FA]/60">Founder · The 5L Method™</p>
              </div>
            </div>
            <div className="mt-12 text-center card-soft p-10">
              <h3 className="font-serif text-2xl font-light text-[#EFE7FA]">Ready to begin your journey?</h3>
              <Link to="/contact" className="btn-primary mt-6 inline-flex">Work With Shantel</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
